import { jsx as t } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import l from "@mui/material/Link";
import s from "styled-components";
const a = {
  root: "linkRoot",
  focusVisible: "linkFocusVisible"
}, p = s(l).withConfig({
  displayName: "StyledLink"
})([
  "&&.linkRoot{color:",
  ";font-size:",
  ";font-weight:",
  ";text-decoration:none;cursor:pointer;outline:none;&:hover{color:",
  ";text-decoration:underline;}&:active{color:",
  ";}}&&.linkFocusVisible{box-shadow:0 0 2px 2px ",
  ";}"
], ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.typography.body200.fontSize, ({ theme: o }) => o.typography.fontWeightRegular, ({ theme: o }) => o.primaryHover, ({ theme: o }) => o.primarySelected, ({ theme: o }) => o.primaryFocus), c = /* @__PURE__ */ n(({ children: o, classes: i, ...e }, r) => /* @__PURE__ */ t(p, {
  ...e,
  ref: r,
  classes: {
    ...a,
    ...i
  },
  underline: "always",
  tabIndex: 0,
  children: o
}));
c.displayName = "Link";
export {
  c as default
};
